import { Card, Col, Row, Empty } from "antd";
import { getInitials } from "helpers/initials";
import React from "react";
import { END_USER_DETAIL_ROUTE, TICKET_MASTER_ROUTE } from "config/route-consts";
import { Link } from "react-router-dom";
import { ticketConversationRepository } from "repositories/ticket-conversation-repository";
import { useTranslation } from "react-i18next";
import { useTicketDetail } from "./TicketDetailHook";
import {
  useTicketConversation,
  TicketConversationItem,
} from "./TicketConversationHook";
import "../TicketView.scss";
import "./TicketDetail.scss";
import { formatDate } from "helpers/date-time";
import TicketConversationInput from "./TicketConversationInput";
import authenticationService from "services/authentication-service";
import {
  API_TICKET_PREFIX,
  API_TICKET_CONVERSATION_PREFIX,
} from "config/api-consts";

function TicketDetail() {
  const [translate] = useTranslation();
  const { validAction } = authenticationService.useAction(
    "ticket",
    API_TICKET_PREFIX
  );
  const { validAction: validTicketConversationAction } =
    authenticationService.useAction(
      "ticketConversation",
      API_TICKET_CONVERSATION_PREFIX
    );

  const { model, handleSetStatus, handleSelfAssign } = useTicketDetail();

  const { list, loading, input, setInput, handleSave } = useTicketConversation(
    ticketConversationRepository.getTicket,
    ticketConversationRepository.create
  );


  const childrenAction = React.useMemo(
    () => (
      <>
        {validAction("update") ? (
          <>
            {model.ticketStatusId === 1 && (
              <button
                className="btn component__btn-primary ticket-detail__action--do"
                onClick={handleSetStatus}
              >
                Xử lý
              </button>
            )}
            {model.ticketStatusId === 2 && (
              <button
                className="btn component__btn-primary"
                onClick={handleSetStatus}
              >
                Hoàn thành
              </button>
            )}
          </>
        ) : (
          <></>
        )}
      </>
    ),
    [handleSetStatus, model.ticketStatusId, validAction]
  );

  return (
    <div className="page page__detail w-100 ticket-detail__container">
      <div className="ticket-detail__head">
        <div className="ticket-detail__head-text">
          <Link to={TICKET_MASTER_ROUTE} className="page-back">
            <i className="tio-chevron_left" aria-hidden />
            {translate("tickets.master.title")}
          </Link>
          <h1 className="ticket-detail__title">{model.title || model.code || "—"}</h1>
        </div>
        <div className="ticket-detail__head-actions">{childrenAction}</div>
      </div>
      <Row gutter={[{ xs: 8, sm: 16, md: 24, lg: 32 }, 12]}>
        <Col className="gutter-row" xs={24} lg={8} xl={6}>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="gutter-row user-info__wrapper" span={24}>
              <Card
                title={
                  <span className="card-title">
                    {translate("tickets.detail.title")}
                  </span>
                }
              >
                <div className="d-flex w-100 user-info__container flex-column">
                  <div
                    className="user-info__content d-flex flex-column flex-grow-1"
                    style={{ borderTop: "none", paddingTop: 0 }}
                  >
                    <div className="d-flex flex-column">
                      <div className="user-info__label-field user-info__label-field--light">
                        {translate("tickets.code")}
                      </div>
                      <div className="user-info__label-content mt-1">
                        {model.code}
                      </div>
                    </div>
                    <div className="d-flex flex-column mt-3">
                      <div className="user-info__label-field user-info__label-field--light">
                        {translate("tickets.endUser")}
                      </div>
                      <div className="user-info__label-content mt-1">
                        {model.endUser?.id ? (
                          <Link className="text-link" to={`${END_USER_DETAIL_ROUTE}?id=${model.endUser.id}`}>
                            {model.endUser.displayName || model.endUser.phoneNumber || model.endUser.email}
                          </Link>
                        ) : (
                          "—"
                        )}
                      </div>
                    </div>
                    <div className="d-flex flex-column mt-3">
                      <div className="user-info__label-field user-info__label-field--light">
                        {translate("tickets.email")}
                      </div>
                      <div className="user-info__label-content mt-1">
                        {model.endUser?.email}
                      </div>
                    </div>
                    <div className="d-flex flex-column mt-3">
                      <div className="user-info__label-field user-info__label-field--light">
                        {translate("tickets.phoneNumber")}
                      </div>
                      <div className="user-info__label-content mt-1">
                        {model.endUser?.phoneNumber}
                      </div>
                    </div>
                    <div className="d-flex flex-column mt-3">
                      <div className="user-info__label-field user-info__label-field--light">
                        {translate("tickets.location")}
                      </div>
                      <div className="user-info__label-content mt-1">
                        {model.location}
                      </div>
                    </div>
                    <div className="d-flex flex-column mt-3">
                      <div className="user-info__label-field user-info__label-field--light">
                        {translate("tickets.ticketStatus")}
                      </div>
                      {model.ticketStatus && (
                        <div
                          className={`ticket__status ticket__status--${model.ticketStatus.code.toLowerCase()} mt-1`}
                        >
                          {model.ticketStatus.name}
                        </div>
                      )}
                    </div>
                    <div className="d-flex flex-column mt-3">
                      <div className="user-info__label-field user-info__label-field--light">
                        {translate("tickets.createdAt")}
                      </div>
                      <div className="user-info__label-content mt-1">
                        {formatDate(model.createdAt, "hh:mm A - DD/MM/YYYY")}
                      </div>
                    </div>
                  </div>
                  <div className="d-flex flex-column ticket-detail__assignee mt-4">
                    <h4>Người phụ trách</h4>
                    {model.appUser ? (
                      <div className="ticket-detail__assignee-info d-flex align-items-center">
                        <span className="ticket-detail__assignee-avatar" aria-hidden>
                          {getInitials(model.appUser.displayName)}
                        </span>
                        <p>{model.appUser.displayName}</p>
                      </div>
                    ) : (
                      <>
                        {validAction("update") && model.ticketStatus?.id !== 3 && (
                          <>
                            <div className="d-flex align-items-center">
                              <button onClick={handleSelfAssign}>
                                <i className="tio-add"></i>
                              </button>
                            </div>
                            <small className="mt-2">
                              (Bấm vào + để gán cho bản thân)
                            </small>
                          </>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </Card>
            </Col>
          </Row>
        </Col>
        <Col className="gutter-row" xs={24} lg={16} xl={18}>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="gutter-row" span={24}>
              <Card
                title={
                  <span className="card-title">
                    {model.code} - {model.title}
                  </span>
                }
              >
                {!loading && list.length > 0 ? (
                  <>
                    {list.map((item) => (
                      <TicketConversationItem item={item} key={item.id} />
                    ))}
                  </>
                ) : (
                  <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description="Chưa có trao đổi nào"
                  />
                )}
                {validTicketConversationAction("create") &&
                  model.ticketStatus?.id !== 3 && (
                    <div className="ticket-detail__input">
                      <TicketConversationInput
                        input={input}
                        setInput={setInput}
                        onSubmit={handleSave}
                        uploadFile={ticketConversationRepository.multiUpload}
                      />
                    </div>
                  )}
              </Card>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
}

export default TicketDetail;
